import { Injectable } from '@angular/core';
import { TableService } from '@shared/services/table.service';

import { Resolve } from '@angular/router';

@Injectable({
  providedIn: "root"
})
export class GetTablesForMenuAPIResolver implements Resolve<any> {
  constructor(private apiService: TableService) {}

  resolve() {
    return this.apiService.getTablesForMenu();
  }
}
